import React, { FC } from "react"
import { FilterAndSortExpression } from "../../../../../../Models/Client/FilterAndSortExpression"
import {
    APIJobModel,
    APIJobQueryModel
} from "../../../../../../Models/API/JobModel"
import { Button } from "dash-styled"
import { NavButton } from "../../../../../Common/NavButton/NavButton"
import { ReviewUnreviewedButton } from "../Common/ReviewUnreviewedButton"
import {
    FetchState,
    getValue
} from "../../../../../../Models/Client/FetchState"
import { routePaths } from "../../../../../../Routes"
import { useDispatch } from "react-redux"
import { push } from "connected-react-router"

interface JobsListReviewButtonProps {
    orgUsername: string
    appID: string
    selectedJobs: APIJobModel[]
    filterAndSort: FilterAndSortExpression<APIJobQueryModel>
    jobListFetch: FetchState<{
        items: APIJobModel[]
        total: number
    }>
    onStartNavigationSelected: () => void
}

export const JobsListReviewButton: FC<JobsListReviewButtonProps> = ({
    orgUsername,
    appID,
    selectedJobs,
    filterAndSort,
    jobListFetch,
    onStartNavigationSelected
}) => {
    const dispatch = useDispatch()

    if (selectedJobs.length > 0) {
        const handleClickReviewSelected = () => {
            onStartNavigationSelected()
            dispatch(
                push(
                    routePaths.jobsDetail(
                        orgUsername,
                        appID,
                        selectedJobs[0].id,
                        filterAndSort
                    )
                )
            )
        }

        return (
            <Button
                testId="review-selected-button"
                onClick={handleClickReviewSelected}
                disabled={(getValue(jobListFetch)?.total ?? 0) === 0}
                className="w-64 mr-4"
            >
                Review selected
            </Button>
        )
    }

    if (filterAndSort.filter.length > 0) {
        return (
            <NavButton
                testId="review-filtered-button"
                to={routePaths.appDetail(orgUsername, appID, {
                    ...filterAndSort,
                    openDetail: true
                })}
                disabled={(getValue(jobListFetch)?.total ?? 0) === 0}
                className="w-64 mr-4"
            >
                Review filtered
            </NavButton>
        )
    }

    return (
        <ReviewUnreviewedButton
            orgUsername={orgUsername}
            appID={appID}
            testId="review-unreviewed-button"
            className="w-64 mr-4"
            sort={filterAndSort.sort}
        >
            Review results
        </ReviewUnreviewedButton>
    )
}
